const _ = require('lodash');

const dtsRender = _.template(`// AUTO GENERATED
// DO NOT EDIT IT MANUALLY
/// <reference types="react" />
import IIconProps, { IconInfo } from '<%= IconProsInterfacePath %>';
declare function Icon(props: IIconProps): JSX.Element;
declare namespace Icon {
\texport const info: IconInfo;
}
export default Icon;
`);

module.exports = dtsRender;
